import axios from "axios"
import { URL_BASE } from '../../../config/config'

const RESOURCE = 'recreations'

export default {

    actions: {
        storeRecreation(context, params) {
            context.commit('PRELOADER', true)
            return new Promise((resolve) => {
                axios.post(`${URL_BASE}${RESOURCE}`, params)
                    .then(response => resolve(response.data))
                    .catch(error => console.log(error))
                    .finally(() => context.commit('PRELOADER', false))
            })
        },
    },

    getters: {

    }

}